import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBell } from 'react-icons/fa';
import { useUser } from '../UserContext';             // adjust path if needed
import { useNotifications } from './NotificationSetup'; // adjust path
import NotificationsList from './NotificationsList';      // adjust path

const Navbar = () => {
  const { user } = useUser();

  return (
    <div className="w-full bg-gradient-hero">
      <div className="container mx-auto flex items-center justify-between py-4 px-1">
        <img
          src="/images/logo2.png"
          alt="ONE Simulation"
          className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
          draggable="false"
        />

        <div className="flex items-center space-x-4">
          {!user ? (
            <>
              <Link to="/login">
                <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
                  Login
                </button>
              </Link>
              
            </>
          ) : (
            <NavbarNotifications />
          )}
        </div>
      </div>
    </div>
  );
};

function NavbarNotifications() {
  const { notifications, setNotifications } = useNotifications();
  const [open, setOpen] = useState(false);

  // Log whenever notifications array changes
  useEffect(() => {
    console.log('🔁 notifications updated in Navbar:', notifications);
  }, [notifications]);

  // Compute unread count
  const unreadCount = Array.isArray(notifications)
    ? notifications.filter((n) => !n.isRead).length
    : 0;

  return (
    <div className="relative">
      <button
        className="relative focus:outline-none"
        onClick={() => setOpen((o) => !o)}
        aria-label="Show notifications"
      >
        <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
        {unreadCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5 shadow">
            {unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="max-h-72 overflow-y-auto">
            <NotificationsList
              notifications={notifications}
              setNotifications={setNotifications}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;
